import {initI18} from "./src/logic/i18n";
initI18("en");

export const wrapRootElement = ({element}) => {
  return element;
}